module.exports = __webpack_public_path__ + "static/media/country_be.3bafbf91.webp";